//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular, { ITimeoutService } from 'angular';

import template from './streams-drawer-tracking-bar.html';
import './streams-drawer-tracking-bar.less';

import { StreamsDrawerTrackingStates } from '@streams-drawer/streams-drawer-constants';

class StreamsDrawerTrackingBar {
    // Bindings
  public onRefreshStream;
  public trackingTimeout;

    // Instance Variables
  public readonly StreamsDrawerTrackingStates = StreamsDrawerTrackingStates;
  public progressBarState;
  public trackingState = StreamsDrawerTrackingStates.NOT_TRACKING;

  public constructor(private $timeout: ITimeoutService) {}

  public $onChanges(changesObj) {
    if (changesObj.trackingTimeout) {
      if (this.trackingTimeout > 0 && StreamsDrawerTrackingStates.NOT_TRACKING) {
        this.trackingState = StreamsDrawerTrackingStates.TRACKING;
        this.progressBarState = 'indeterminate';

        this.$timeout(() => {
          this.trackingState = StreamsDrawerTrackingStates.TRACKING_COMPLETE;
          this.progressBarState = 1;
        }, this.trackingTimeout);
      } else {
        this.trackingState = StreamsDrawerTrackingStates.NOT_TRACKING;
      }
    }
  }

  public refreshStream() {
    this.onRefreshStream();
    this.trackingState = StreamsDrawerTrackingStates.NOT_TRACKING;
  }
}

angular.module('curalate').component('streamsDrawerTrackingBar', {
  controller: [
    '$timeout',
    StreamsDrawerTrackingBar,
  ],
  bindings: {
    trackingTimeout: '<',
    onRefreshStream: '&',
  },
  template,
});
